import {
  DollarOutlined,
  ProductOutlined,
  PropertySafetyOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Spin } from 'antd'
import { useCallback, useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

import P2PChart from './chart/p2p-chart'
import PTOChart from './chart/pto-chart'
import ReferralChart from './chart/referral-chart'
import StakedChart from './chart/stake-chart'
import BoosterOverviewSection from './booster-overview-section'

import './style.scss'

export default function Dashboard() {
  const [data, setData] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const getData = async () => {
    try {
      const res = await AppAdmin.getDashboard()
      if (res?.data.success) {
        setData(res?.data.data)
      }
    } catch (err) {
      logError(err)
    }
  }

  const getDataFirstTime = useCallback(async () => {
    setLoading(true)
    try {
      await getData()
    } catch (err) {
      logError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getDataFirstTime()
  }, [getDataFirstTime])

  return (
    <>
      <div className="main-section dashboard">
        <div className="main-title" style={{ marginBottom: 20 }}>
          Dashboard
        </div>
        <div className="dashboard-container">
          <div className="wrap-dashboard">
            {
              // (role?.includes(1) || role?.includes(2) || role?.includes(3)) &&
              <div className="wrap-box">
                <div className="title">Staked Overview</div>
                <div className="wrap-columns flex-box">
                  <div className="left-col">
                    <div className="columns">
                      <div className="top-row">
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Users</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.staked?.totalUser)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <UserOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Staked (MEY)</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    <>
                                      {new Intl.NumberFormat('en-US').format(
                                        data.staked?.totalStaked
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <DollarOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bot-row">
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Pool Cap (MEY)</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    <>
                                      {new Intl.NumberFormat('en-US').format(data.staked?.poolCap)}
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <DollarOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Remaining Pool (MEY)</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(
                                      data.staked?.remainingPool
                                    )
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <DollarOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="right-col">
                    <div className="wrap-chart">
                      <div className="chart-box">
                        <div className="columns">
                          <div className="colum w-4">
                            <div className="line-chart">
                              <div className="content-chart">
                                <div className="title">Staked Overview</div>
                                <StakedChart data={data && data.staked} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {
              // (role?.includes(1) || role?.includes(4) || role?.includes(5)) &&
              <div className="wrap-box">
                <div className="title">P2P Overview</div>
                <div className="wrap-columns flex-box">
                  <div className="left-col">
                    <div className="columns">
                      <div className="top-row">
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Investors</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.p2p?.totalLend)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <UserOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Investment (USDC)</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.p2p?.totalLendAmount)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <DollarOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bot-row">
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Funding Target (USDC)</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.p2p?.fundingTarget)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <DollarOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Properties</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.p2p?.remainingTarget)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <ProductOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="right-col">
                    <div className="wrap-chart">
                      <div className="chart-box">
                        <div className="columns">
                          <div className="colum w-4">
                            <div className="line-chart">
                              <div className="content-chart">
                                <div className="title">P2P Overview</div>
                                <P2PChart data={data && data.p2p} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {
              // (role?.includes(1) || role?.includes(11)) &&
              <div className="wrap-box">
                <div className="title">Affiliates Overview</div>
                <div className="wrap-columns flex-box">
                  <div className="left-col">
                    <div className="columns">
                      <div className="top-row">
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Users</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.referral?.totalUser)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <UserOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Users Stake</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(
                                      data.referral?.totalUserStake
                                    )
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <UserOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bot-row">
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Reward Amount (MEY)</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(
                                      data.referral?.totalRewardMey
                                    )
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <DollarOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Reward Amount (USDC)</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(
                                      data.referral?.totalRewardUsdc
                                    )
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <DollarOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="right-col">
                    <div className="wrap-chart">
                      <div className="chart-box">
                        <div className="columns">
                          <div className="colum w-4">
                            <div className="line-chart">
                              <div className="content-chart">
                                <div className="title">Affiliates Overview</div>
                                <ReferralChart data={data && data.referral} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

            {
              // (role?.includes(1) || role?.includes(6) || role?.includes(7)) &&
              <div className="wrap-box">
                <div className="title">PTO Overview</div>
                <div className="wrap-columns flex-box">
                  <div className="left-col">
                    <div className="columns">
                      <div className="top-row">
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Token Issued</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.pto?.tokenIssued)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <PropertySafetyOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Token Issued Sold</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.pto?.totalIssuedSell)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <PropertySafetyOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bot-row">
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Funding Target (USDC)</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.pto?.fundingTarget)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <DollarOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="colum w-3">
                          <div className="guide-box">
                            <div className="box-content">
                              <div className="left-s">
                                <div className="txt">Total Amount Sold (USDC)</div>
                                <div className="number">
                                  {loading ? (
                                    <Spin />
                                  ) : (
                                    new Intl.NumberFormat('en-US').format(data.pto?.totalAmountSell)
                                  )}
                                </div>
                              </div>
                              <div className="right-s">
                                <div className="icon">
                                  <DollarOutlined />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="right-col">
                    <div className="wrap-chart">
                      <div className="chart-box">
                        <div className="columns">
                          <div className="colum w-4">
                            <div className="line-chart">
                              <div className="content-chart">
                                <div className="title">PTO Overview</div>
                                <PTOChart data={data && data.pto} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

            <BoosterOverviewSection />
          </div>
        </div>
        {/* <div className="wrap-chart">
          <div className="chart-box">
            <div className="columns">
              <div className="colum w-4">
                <div className="line-chart">
                  <div className="content-chart">
                    <div className="title">
                      Staked Overview
                    </div>
                    <StakedChart data={data && data.staked} />
                  </div>
                </div>
              </div>
              <div className="colum w-4">
                <div className="line-chart">
                  <div className="content-chart">
                    <div className="title">
                      P2P Overview
                    </div>
                    <P2PChart data={data && data.p2p} />
                  </div>
                </div>
              </div>
              <div className="colum w-4">
                <div className="line-chart">
                  <div className="content-chart">
                    <div className="title">
                      Referral Overview
                    </div>
                    <ReferralChart data={data && data.referral} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  )
}
